module.exports = __webpack_public_path__ + "static/media/5.d1d086d9.png";